module.exports = __webpack_public_path__ + "img/chefkok_light.39f89fec.png";